const { API_METHODS, API_AUTH_TYPES, API_HEADER_CONTENT_TYPES, API_GATEWAY_TYPES } = require('@bcm/constants');

const defaults = {
  contentType: API_HEADER_CONTENT_TYPES.json,
  gatewayPriority: API_GATEWAY_TYPES.websocket,
  authorization: API_AUTH_TYPES.idToken,
};

const defaultQueryStrings = [
  'state',
  'page',
  'pageSize',
  'exclusiveStartKey',
  'filters',
];

const userQueryStrings = [
  ...defaultQueryStrings,
  'userType',
];

const workspaceQueryStrings = [
  ...defaultQueryStrings,
  'workspaceType',
];

const userWorkspaceQueryStrings = [
  ...defaultQueryStrings,
  'workspaceType',
  'userType',
];

const channelQueryStrings = [
  ...defaultQueryStrings,
  'workspaceType',
  'channelType',
];

const userChannelQueryStrings = [
  ...defaultQueryStrings,
  'workspaceType',
  'channelType',
  'userType',
];

const conferenceRoomQueryStrings = [
  ...defaultQueryStrings,
  'workspaceType',
  'channelType',
  'conferenceRoomType',
];

const userConferenceRoomQueryStrings = [
  ...defaultQueryStrings,
  'workspaceType',
  'channelType',
  'conferenceRoomType',
  'userType',
];

const libraryQueryStrings = [
  ...defaultQueryStrings,
  'libraryType',
];

const libraryTagQueryStrings = [
  ...defaultQueryStrings,
  'libraryType',
  'tagOwnerType',
];

const userLibraryTagQueryStrings = [
  ...defaultQueryStrings,
  'userType',
  'libraryType',
  'tagOwnerType',
];

const pageGetOneQueryStrings = [
  ...defaultQueryStrings,
  'libraryType',
  'libraryId'
];

const calendarObjectQueryStrings = [
  ...defaultQueryStrings,
  'ownerType',
  'calendarObjectType',
  'userType',
];

const calendarObjectGetPageQueryStrings = [
  ...calendarObjectQueryStrings,
  'startDate',
  'endDate',
  'isHidRule',
];


module.exports = {

  // Health
  healthPing: {
    ...defaults,
    method: API_METHODS.get,
    authorization: API_AUTH_TYPES.noAuth,
    RESTPath: '/api/v1',
    RESTPathBuild: () => '/api/v1',
    params: null,
    queryStrings: null,
    WSRoute: 'healthPing',
  },

  // Auth
  authAdminResetPassword: {
    ...defaults,
    method: API_METHODS.post,
    authorization: API_AUTH_TYPES.idToken,
    RESTPath: '/api/v1/auth/adminResetPassword',
    RESTPathBuild: () => '/api/v1/auth/adminResetPassword',
    params: null,
    queryStrings: null,
    WSRoute: 'authAdminResetPassword',
  },
  authConfirmForgotPassword: {
    ...defaults,
    method: API_METHODS.post,
    authorization: API_AUTH_TYPES.noAuth,
    RESTPath: '/api/v1/auth/confirmForgotPassword',
    RESTPathBuild: () => '/api/v1/auth/adminResetPassword',
    params: null,
    queryStrings: null,
    WSRoute: 'authConfirmForgotPassword',
    maskErrors: true,
  },
  authForgotPassword: {
    ...defaults,
    method: API_METHODS.post,
    authorization: API_AUTH_TYPES.noAuth,
    RESTPath: '/api/v1/auth/forgotPassword',
    RESTPathBuild: () => '/api/v1/auth/forgotPassword',
    params: null,
    queryStrings: null,
    WSRoute: 'authForgotPassword',
    maskErrors: true,
  },
  authLogin: {
    ...defaults,
    method: API_METHODS.post,
    authorization: API_AUTH_TYPES.noAuth,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/auth/login',
    RESTPathBuild: () => '/api/v1/auth/login',
    params: null,
    queryStrings: null,
    WSRoute: null,
    maskErrors: true,
  },
  authRefresh: {
    ...defaults,
    method: API_METHODS.post,
    authorization: API_AUTH_TYPES.refresh,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/auth/refresh',
    RESTPathBuild: () => '/api/v1/auth/refresh',
    params: null,
    queryStrings: null,
    WSRoute: null,
    maskErrors: true,
  },
  authUserResetPassword: {
    ...defaults,
    method: API_METHODS.post,
    authorization: API_AUTH_TYPES.noAuth,
    RESTPath: '/api/v1/auth/userResetPassword',
    RESTPathBuild: () => '/api/v1/auth/userResetPassword',
    params: null,
    queryStrings: null,
    WSRoute: 'authUserResetPassword',
    maskErrors: true,
  },

  // Org
  orgCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/orgs',
    RESTPathBuild: () => '/api/v1/orgs',
    params: null,
    queryStrings: defaultQueryStrings,
    WSRoute: 'orgCreate',
  },
  orgGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/orgs',
    RESTPathBuild: () => '/api/v1/orgs',
    params: null,
    queryStrings: defaultQueryStrings,
    WSRoute: 'orgGetPage',
  },
  orgGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/orgs/:orgId',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'orgGetOne',
  },
  orgUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/orgs/:orgId',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'orgUpdate',
  },
  orgDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/orgs/:orgId',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'orgDelete',
  },

  // User
  userCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/users',
    RESTPathBuild: () => '/api/v1/users',
    params: null,
    queryStrings: defaultQueryStrings,
    WSRoute: 'userCreate',
  },
  userGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users',
    RESTPathBuild: () => '/api/v1/users',
    params: null,
    queryStrings: userQueryStrings,
    WSRoute: 'userGetPage',
  },
  userGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userGetOne',
  },
  userUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userUpdate',
  },
  userDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userDelete',
  },
  userGetPageByOrgId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/orgs/:orgId/users',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/users`,
    params: ['orgId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userGetPageByOrgId',
  },

  // User Pin
  userPinCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/users/:userId/pin',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/pin`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userPinCreate',
  },
  userPinGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/pin',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/pin`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userPinGetOne',
  },
  userPinUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId/pin',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/pin`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userPinUpdate',
  },
  userPinDelete: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/pin',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/pin`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userPinDelete',
  },

  // User Account Settings
  accountSettingCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/users/:userId/accountSetting',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/accountSetting`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'accountSettingCreate',
  },
  accountSettingGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/accountSetting',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/accountSetting`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'accountSettingGetOne',
  },
  accountSettingUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId/accountSetting',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/accountSetting`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'accountSettingUpdate',
  },
  accountSettingDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId/accountSetting',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/accountSetting`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'accountSettingDelete',
  },

  // User Profile Pictures
  profilePictureCreate: {
    ...defaults,
    method: API_METHODS.post,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/users/:userId/profilePictures',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/profilePictures`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'profilePictureCreate',
  },
  profilePictureGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/profilePictures',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/profilePictures`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'profilePictureGetOne',
  },
  profilePictureGetPage: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/profilePictures',
    RESTPathBuild: () => '/api/v1/profilePictures',
    params: null,
    queryStrings: defaultQueryStrings,
    WSRoute: 'profilePictureGetPage',
  },
  profilePictureUpdate: {
    ...defaults,
    method: API_METHODS.put,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/users/:userId/profilePictures',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/profilePictures`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'profilePictureUpdate',
  },
  profilePictureDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId/profilePictures',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/profilePictures`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'profilePictureDelete',
  },

  // Qualifications
  qualificationCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/users/:userId/qualifications',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/qualifications`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'qualificationCreate',
  },
  qualificationGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/qualifications',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/qualifications`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'qualificationGetPage',
  },
  qualificationGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/qualifications/:qualificationId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/qualifications/${p.qualificationId}`,
    params: ['userId', 'qualificationId'],
    queryStrings: userQueryStrings,
    WSRoute: 'qualificationGetOne',
  },
  qualificationUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId/qualifications/:qualificationId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/qualifications/${p.qualificationId}`,
    params: ['userId', 'qualificationId'],
    queryStrings: userQueryStrings,
    WSRoute: 'qualificationUpdate',
  },
  qualificationDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId/qualifications/:qualificationId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/qualifications/${p.qualificationId}`,
    params: ['userId', 'qualificationId'],
    queryStrings: userQueryStrings,
    WSRoute: 'qualificationDelete',
  },

  // Workspace
  workspaceCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/workspaces',
    RESTPathBuild: () => '/api/v1/workspaces',
    params: null,
    queryStrings: workspaceQueryStrings,
    WSRoute: 'workspaceCreate',
  },
  workspaceGetPageByUserId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/workspaces',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces`,
    params: ['userId'],
    queryStrings: userWorkspaceQueryStrings,
    WSRoute: 'workspaceGetPageByUserId',
  },
  workspaceGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/workspaces/:workspaceId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}`,
    params: ['workspaceId'],
    queryStrings: workspaceQueryStrings,
    WSRoute: 'workspaceGetOne',
  },
  workspaceUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/workspaces/:workspaceId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}`,
    params: ['workspaceId'],
    queryStrings: workspaceQueryStrings,
    WSRoute: 'workspaceUpdate',
  },
  workspaceDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/workspaces/:workspaceId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}`,
    params: ['workspaceId'],
    queryStrings: workspaceQueryStrings,
    WSRoute: 'workspaceDelete',
  },
  workspaceInviteUserToWorkspace: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/users/:userId/workspaces/:workspaceId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces/${p.workspaceId}`,
    params: ['userId', 'workspaceId'],
    queryStrings: workspaceQueryStrings,
    WSRoute: 'workspaceInviteUserToWorkspace',
  },
  // workspaceAcceptUserToWorkspaceInvite: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/users/:userId/workspaces/:workspaceId',
  //   RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces/${p.workspaceId}`,
  //   params: ['userId', 'workspaceId'],
  //   queryStrings: userWorkspaceQueryStrings,
  //   WSRoute: 'workspaceAcceptUserToWorkspaceInvite',
  // },
  workspaceDeleteUserFromWorkspace: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId/workspaces/:workspaceId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces/${p.workspaceId}`,
    params: ['userId', 'workspaceId'],
    queryStrings: userWorkspaceQueryStrings,
    WSRoute: 'workspaceDeleteUserFromWorkspace',
  },
  workspaceUserToWorkspaceUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId/workspaces/:workspaceId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces/${p.workspaceId}`,
    params: ['userId', 'workspaceId'],
    queryStrings: userWorkspaceQueryStrings,
    WSRoute: 'workspaceUserToWorkspaceUpdate',
  },

  // Channels
  channelCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels`,
    params: ['workspaceId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'channelCreate',
  },
  channelGetPageByUserId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/workspaces/:workspaceId/channels',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces/${p.workspaceId}/channels`,
    params: ['userId', 'workspaceId'],
    queryStrings: userChannelQueryStrings,
    WSRoute: 'channelGetPageByUserId',
  },
  channelGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}`,
    params: ['workspaceId', 'channelId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'channelGetOne',
  },
  channelUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}`,
    params: ['workspaceId', 'channelId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'channelUpdate',
  },
  channelDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}`,
    params: ['workspaceId', 'channelId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'channelDelete',
  },
  channelInviteUsersToChannel: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/users',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/users`,
    params: ['workspaceId', 'channelId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'channelInviteUsersToChannel',
  },
  // channelAcceptUserToChannelInvite: {
  // ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/users/:userId/workspaces/:workspaceId/channels/:channelId',
  //   RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces/${p.workspaceId}/channels/${p.channelId}`,
  //   params: ['userId', 'workspaceId', 'channelId'],
  //   queryStrings: userChannelQueryStrings,
  //   WSRoute: 'channelAcceptUserToChannelInvite',
  // },
  channelDeleteUserFromChannel: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId/workspaces/:workspaceId/channels/:channelId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces/${p.workspaceId}/channels/${p.channelId}`,
    params: ['userId', 'workspaceId', 'channelId'],
    queryStrings: userChannelQueryStrings,
    WSRoute: 'channelDeleteUserFromChannel',
  },
  channelUserToChannelUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId/workspaces/:workspaceId/channels/:channelId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/workspaces/${p.workspaceId}/channels/${p.channelId}`,
    params: ['userId', 'workspaceId', 'channelId'],
    queryStrings: userChannelQueryStrings,
    WSRoute: 'channelUserToChannelUpdate',
  },
  channelUsersGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/users',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/users`,
    params: ['workspaceId', 'channelId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'channelUsersGetPage',
  },

  // Messages
  messageCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/messages',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/messages`,
    params: ['workspaceId', 'channelId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'messageCreate',
  },
  messageGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/messages',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/messages`,
    params: ['workspaceId', 'channelId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'messageGetPage',
  },
  messageUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/messages/:messageId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/messages/${p.messageId}`,
    params: ['workspaceId', 'channelId', 'messageId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'messageUpdate',
  },
  messageDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/messages/:messageId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/messages/${p.messageId}`,
    params: ['workspaceId', 'channelId', 'messageId'],
    queryStrings: channelQueryStrings,
    WSRoute: 'messageDelete',
  },

  // EOCs
  eocCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs',
    RESTPathBuild: () => '/api/v1/eocs',
    params: null,
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocCreate',
  },
  eocGetPageByUserId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/eocs',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/eocs`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'eocGetPageByUserId',
  },
  eocGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocGetOne',
  },
  eocUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/eocs/:eocId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocUpdate',
  },
  eocDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocDelete',
  },
  eocDashboardGet: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/dashboard',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/dashboard`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocDashboardGet',
  },
  eocInvitePatientToEoc: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/patient',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/patient`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocInvitePatientToEoc',
  },
  eocInviteUsersToEoc: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/users',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/users`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocInviteUsersToEoc',
  },
  // eocAnswerUserToEocInvite: {
  // ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/eocs/:eocId/users/:userId',
  //   RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/users/${p.userId}`,
  //   params: ['eocId', 'userId'],
  //   queryStrings: userQueryStrings,
  //   WSRoute: 'eocAnswerUserToEocInvite',
  // },
  eocDeleteUserFromEoc: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/users/:userId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/users/${p.userId}`,
    params: ['eocId', 'userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'eocDeleteUserFromEoc',
  },
  eocUsersGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/users',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/users`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocUsersGetPage',
  },
  eocExport: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/eocExport',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/eocExport`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocExport',
  },
  // Eoc Emergency Room Sign Up
  eocSecureLinkCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocSecureLinks',
    RESTPathBuild: () => '/api/v1/eocSecureLinks',
    params: null,
    queryStrings: null,
    WSRoute: 'eocSecureLinkCreate',
  },

  // Conditions
  conditionCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/conditions',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionCreate',
  },
  conditionGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionGetPage',
  },
  conditionGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionGetOne',
  },
  conditionUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionUpdate',
  },
  conditionDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionDelete',
  },

  // Condition Annotations
  conditionAnnotationCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/annotations',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/annotations`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionAnnotationCreate',
  },
  conditionAnnotationGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/annotations',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/annotations`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionAnnotationGetPage',
  },
  conditionAnnotationGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionAnnotationGetOne',
  },
  conditionAnnotationUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionAnnotationUpdate',
  },
  conditionAnnotationDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'conditionAnnotationDelete',
  },

  // Body Sites
  bodySiteCreate: {
    ...defaults,
    method: API_METHODS.post,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteCreate',
  },
  bodySiteGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteGetPage',
  },
  bodySiteGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites/:bodySiteId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites/${p.bodySiteId}`,
    params: ['eocId', 'conditionId', 'bodySiteId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteGetOne',
  },
  bodySiteUpdate: {
    ...defaults,
    method: API_METHODS.put,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites/:bodySiteId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites/${p.bodySiteId}`,
    params: ['eocId', 'conditionId', 'bodySiteId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteUpdate',
  },
  bodySiteDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites/:bodySiteId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites/${p.bodySiteId}`,
    params: ['eocId', 'conditionId', 'bodySiteId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteDelete',
  },

  // Body Site Annotations
  bodySiteAnnotationCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites/:bodySiteId/annotations',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites/${p.bodySiteId}/annotations`,
    params: ['eocId', 'conditionId', 'bodySiteId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteAnnotationCreate',
  },
  bodySiteAnnotationGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites/:bodySiteId/annotations',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites/${p.bodySiteId}/annotations`,
    params: ['eocId', 'conditionId', 'bodySiteId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteAnnotationGetPage',
  },
  bodySiteAnnotationGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites/:bodySiteId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites/${p.bodySiteId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'bodySiteId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteAnnotationGetOne',
  },
  bodySiteAnnotationUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites/:bodySiteId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites/${p.bodySiteId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'bodySiteId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteAnnotationUpdate',
  },
  bodySiteAnnotationDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/bodySites/:bodySiteId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/bodySites/${p.bodySiteId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'bodySiteId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bodySiteAnnotationDelete',
  },

  // Image Sets
  imageSetCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSetCreate',
  },
  imageSetGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets`,
    params: ['eocId', 'conditionId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSetGetPage',
  },
  imageSetGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}`,
    params: ['eocId', 'conditionId', 'imageSetId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSetGetOne',
  },
  imageSetUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}`,
    params: ['eocId', 'conditionId', 'imageSetId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSetUpdate',
  },
  imageSetDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}`,
    params: ['eocId', 'conditionId', 'imageSetId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSetDelete',
  },

  // Image
  imageCreate: {
    ...defaults,
    method: API_METHODS.post,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images`,
    params: ['eocId', 'conditionId', 'imageSetId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageCreate',
  },
  imageGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images`,
    params: ['eocId', 'conditionId', 'imageSetId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageGetPage',
  },
  imageGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageGetOne',
  },
  imageUpdate: {
    ...defaults,
    method: API_METHODS.put,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageUpdate',
  },
  imageDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageDelete',
  },

  // Image Analyze
  imageAnalyzeCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/analyze',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/analyze`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnalyzeCreate',
  },
  imageAnalyzeGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/analyze',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/analyze`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnalyzeGetPage',
  },
  imageAnalyzeGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/analyze/:analyzeId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/analyze/${p.analyzeId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'analyzeId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnalyzeGetOne',
  },
  imageAnalyzeUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/analyze/:analyzeId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/analyze/${p.analyzeId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'analyzeId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnalyzeUpdate',
  },
  imageAnalyzeDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/analyze/:analyzeId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/analyze/${p.analyzeId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'analyzeId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnalyzeDelete',
  },

  // Image Sketch
  imageSketchCreate: {
    ...defaults,
    method: API_METHODS.post,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/imageSketches',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/imageSketches`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSketchCreate',
  },
  imageSketchGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/imageSketches/:imageSketchId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/imageSketches/${p.imageSketchId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'imageSketchId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSketchGetOne',
  },
  imageSketchUpdate: {
    ...defaults,
    method: API_METHODS.put,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/imageSketches/:imageSketchId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/imageSketches/${p.imageSketchId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'imageSketchId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSketchUpdate',
  },
  imageSketchDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/imageSketches/:imageSketchId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/imageSketches/${p.imageSketchId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'imageSketchId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageSketchDelete',
  },

  // Image Annotations
  imageAnnotationCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/annotations',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/annotations`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnnotationCreate',
  },
  imageAnnotationGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/annotations',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/annotations`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnnotationGetPage',
  },
  imageAnnotationGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnnotationGetOne',
  },
  imageAnnotationUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnnotationUpdate',
  },
  imageAnnotationDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/eocs/:eocId/conditions/:conditionId/imageSets/:imageSetId/images/:imageId/annotations/:annotationId',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/conditions/${p.conditionId}/imageSets/${p.imageSetId}/images/${p.imageId}/annotations/${p.annotationId}`,
    params: ['eocId', 'conditionId', 'imageSetId', 'imageId', 'annotationId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'imageAnnotationDelete',
  },

  // Website Path
  websitePostContact: {
    ...defaults,
    method: API_METHODS.post,
    authorization: API_AUTH_TYPES.noAuth,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/website/contact',
    RESTPathBuild: () => '/api/v1/website/contact',
    params: null,
    queryStrings: null,
    WSRoute: null,
    maskErrors: true,
  },

  // WebRtc Paths
  // webRtcRoomClose: {
  //   ...defaults,
  //   method: API_METHODS.delete,
  //   RESTPath: '/api/v1/webRtcRooms/:roomId',
  //   RESTPathBuild: (p) => `/api/v1/webRtcRooms/${p.roomId}`,
  //   params: ['roomId'],
  //   queryStrings: userQueryStrings,
  //   WSRoute: 'webRtcRoomClose',
  // },
  webRtcRoomUserGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/webRtcRooms/:roomId/users',
    RESTPathBuild: (p) => `/api/v1/webRtcRooms/${p.roomId}/users`,
    params: ['roomId'],
    queryStrings: userQueryStrings,
    WSRoute: 'webRtcRoomUserGetPage',
  },
  webRtcRoomUserJoin: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/webRtcRooms/:roomId/users/:userId',
    RESTPathBuild: (p) => `/api/v1/webRtcRooms/${p.roomId}/users/${p.userId}`,
    params: ['roomId', 'userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'webRtcRoomUserJoin',
  },
  webRtcRoomUserMessage: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/webRtcRooms/:roomId/users/:userId/message',
    RESTPathBuild: (p) => `/api/v1/webRtcRooms/${p.roomId}/users/${p.userId}/message`,
    params: ['roomId', 'userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'webRtcRoomUserMessage',
  },
  webRtcRoomUserLeave: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/webRtcRooms/:roomId/users/:userId',
    RESTPathBuild: (p) => `/api/v1/webRtcRooms/${p.roomId}/users/${p.userId}`,
    params: ['roomId', 'userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'webRtcRoomUserLeave',
  },

  // Daily WebRtc Paths
  conferenceRoomCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms`,
    params: ['workspaceId', 'channelId'],
    queryStrings: conferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomCreate',
  },
  conferenceRoomGetByChannelId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms`,
    params: ['workspaceId', 'channelId'],
    queryStrings: conferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomGetByChannelId',
  },
  conferenceRoomDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms/:conferenceRoomId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms/${p.conferenceRoomId}`,
    params: ['workspaceId', 'channelId', 'conferenceRoomId'],
    queryStrings: conferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomDelete',
  },
  conferenceRoomTranscriptGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms/:conferenceRoomId/transcripts',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms/${p.conferenceRoomId}/transcripts`,
    params: ['workspaceId', 'channelId', 'conferenceRoomId'],
    queryStrings: conferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomTranscriptGetOne',
  },
  conferenceRoomTranscriptUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms/:conferenceRoomId/transcripts',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms/${p.conferenceRoomId}/transcripts`,
    params: ['workspaceId', 'channelId', 'conferenceRoomId'],
    queryStrings: conferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomTranscriptUpdate',
  },
  conferenceRoomUsersGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms/:conferenceRoomId/users',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms/${p.conferenceRoomId}/users`,
    params: ['workspaceId', 'channelId', 'conferenceRoomId'],
    queryStrings: conferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomUsersGetPage',
  },
  conferenceRoomUserJoin: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms/:conferenceRoomId/users/:userId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms/${p.conferenceRoomId}/users/${p.userId}`,
    params: ['workspaceId', 'channelId', 'conferenceRoomId', 'userId'],
    queryStrings: userConferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomUserJoin',
  },
  conferenceRoomUserLeave: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms/:conferenceRoomId/users/:userId',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms/${p.conferenceRoomId}/users/${p.userId}`,
    params: ['workspaceId', 'channelId', 'conferenceRoomId', 'userId'],
    queryStrings: userConferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomUserLeave',
  },
  conferenceRoomUserMessage: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/workspaces/:workspaceId/channels/:channelId/conferenceRooms/:conferenceRoomId/users/:userId/message',
    RESTPathBuild: (p) => `/api/v1/workspaces/${p.workspaceId}/channels/${p.channelId}/conferenceRooms/${p.conferenceRoomId}/users/${p.userId}/message`,
    params: ['workspaceId', 'channelId', 'conferenceRoomId', 'userId'],
    queryStrings: userConferenceRoomQueryStrings,
    WSRoute: 'conferenceRoomUserMessage',
  },

  dictationRoomCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/users/:userId/dictationRooms',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/dictationRooms`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'dictationRoomCreate',
  },
  dictationRoomDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId/dictationRooms/:dictationRoomId',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/dictationRooms/${p.dictationRoomId}`,
    params: ['userId', 'dictationRoomId'],
    queryStrings: userQueryStrings,
    WSRoute: 'dictationRoomDelete',
  },

  // Websocket path
  websocketUserConnectionHealthCheck: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/websockets/:userId',
    RESTPathBuild: (p) => `/api/v1/websockets/${p.userId}`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'websocketUserConnectionHealthCheck',
  },

  tagGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/tagOwnerTypes/:tagOwnerType/owners/:ownerId/tagTypes/:tagType',
    RESTPathBuild: (p) => `/api/v1/tagOwnerTypes/${p.tagOwnerType}/owners/${p.ownerId}/tagTypes/${p.tagType}`,
    params: ['tagOwnerType', 'ownerId', 'tagType'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'tagGetPage',
  },

  // Teams
  teamCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/orgs/:orgId/teams',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/teams`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'teamCreate',
  },
  teamGetPageByOrgId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/orgs/:orgId/teams',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/teams`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'teamGetPageByOrgId',
  },
  teamUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/orgs/:orgId/teams/:teamId',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/teams/${p.teamId}`,
    params: ['orgId', 'teamId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'teamUpdate',
  },
  teamGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/orgs/:orgId/teams/:teamId',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/teams/${p.teamId}`,
    params: ['orgId', 'teamId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'teamGetOne',
  },
  teamGetPageByUserId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/teams',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/teams`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'teamGetPageByUserId',
  },
  teamDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/orgs/:orgId/teams/:teamId',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/teams/${p.teamId}`,
    params: ['orgId', 'teamId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'teamDelete',
  },
  teamUpdateUsers: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/orgs/:orgId/teams/:teamId/users',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/teams/${p.teamId}/users`,
    params: ['orgId', 'teamId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'teamUpdateUsers',
  },
  teamUpdateEoc: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/eocs/:eocId/teams',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/teams`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'teamUpdateEoc',
  },
  teamGetPageByEocId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/teams',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/teams`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'teamGetPageByEocId',
  },

  // Resource Sharing: library
  // libraryCreate: {
  //   ...defaults,
  //   method: API_METHODS.post,
  //   RESTPath: '/api/v1/libraryType/:libraryType/libraries',
  //   RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries`,
  //   params: ['libraryType'],
  //   WSRoute: 'libraryCreate',
  // },
  // libraryGetPage: {
  //   ...defaults,
  //   method: API_METHODS.get,
  //   RESTPath: '/api/v1/libraryType/:libraryType/libraries',
  //   RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries`,
  //   params: ['libraryType'],
  //   WSRoute: 'libraryGetPage',
  // },
  libraryGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/libraryType/:libraryType/libraries/:libraryId',
    RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries/${p.libraryId}`,
    params: ['libraryType', 'libraryId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'libraryGetOne',
  },
  // libraryUpdate: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/libraryType/:libraryType/libraries/:libraryId',
  //   RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries/${p.libraryId}`,
  //   params: ['libraryType', 'libraryId'],
  //   WSRoute: 'libraryUpdate',
  // },
  // libraryDelete: {
  //   ...defaults,
  //   method: API_METHODS.delete,
  //   RESTPath: '/api/v1/libraryType/:libraryType/libraries/:libraryId',
  //   RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries/${p.libraryId}`,
  //   params: ['libraryType', 'libraryId'],
  //   WSRoute: 'libraryDelete',
  // },
  // libraryClone: {
  //   ...defaults,
  //   method: API_METHODS.post,
  //   RESTPath: '/api/v1/libraryType/:libraryType/libraries/:libraryId/clone',
  //   RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries/${p.libraryId}/clone`,
  //   params: ['libraryType', 'libraryId'],
  //   WSRoute: 'libraryClone',
  // },

  // Resource Sharing: book
  bookCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/books',
    RESTPathBuild: () => '/api/v1/books',
    params: [],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bookCreate',
  },
  // bookGetPage: {
  //   ...defaults,
  //   method: API_METHODS.get,
  //   RESTPath: '/api/v1/books',
  //   RESTPathBuild: (p) => '/api/v1/books',
  //   params: [],
  //   WSRoute: 'bookGetPage',
  // },
  bookGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/books/:bookId',
    RESTPathBuild: (p) => `/api/v1/books/${p.bookId}`,
    params: ['bookId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bookGetOne',
  },
  bookUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/books/:bookId',
    RESTPathBuild: (p) => `/api/v1/books/${p.bookId}`,
    params: ['bookId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bookUpdate',
  },
  userDeleteGroupBook: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/libraries/:libraryId/books/:bookId',
    RESTPathBuild: (p) => `/api/v1/libraries/${p.libraryId}/books/${p.bookId}`,
    params: ['bookId', 'libraryId'],
    queryStrings: libraryQueryStrings,
    WSRoute: 'userDeleteGroupBook',
  },
  // bookClone: {
  //   ...defaults,
  //   method: API_METHODS.post,
  //   RESTPath: '/api/v1/books/:bookId/clone',
  //   RESTPathBuild: (p) => `/api/v1/books/${p.bookId}/clone`,
  //   params: ['bookId'],
  //   WSRoute: 'bookClone',
  // },

  // Resource Sharing: page
  pageCreate: {
    ...defaults,
    method: API_METHODS.post,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/pages',
    RESTPathBuild: () => '/api/v1/pages',
    params: [],
    queryStrings: defaultQueryStrings,
    WSRoute: 'pageCreate',
  },
  // pageGetPage: {
  //   ...defaults,
  //   method: API_METHODS.get,
  //   RESTPath: '/api/v1/pages',
  //   RESTPathBuild: (p) => '/api/v1/pages',
  //   params: [],
  //   WSRoute: 'pageGetPage',
  // },
  pageGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/pages/:pageId',
    RESTPathBuild: (p) => `/api/v1/pages/${p.pageId}`,
    params: ['pageId'],
    queryStrings: pageGetOneQueryStrings, // TODO: fix temporary solution
    WSRoute: 'pageGetOne',
  },
  pageUpdate: {
    ...defaults,
    method: API_METHODS.put,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    RESTPath: '/api/v1/pages/:pageId',
    RESTPathBuild: (p) => `/api/v1/pages/${p.pageId}`,
    params: ['pageId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'pageUpdate',
  },
  userDeleteGroupPage: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/libraries/:libraryId/pages/:pageId',
    RESTPathBuild: (p) => `/api/v1/libraries/${p.libraryId}/pages/${p.pageId}`,
    params: ['pageId', 'libraryId'],
    queryStrings: libraryQueryStrings,
    WSRoute: 'userDeleteGroupPage',
  },
  // pageClone: {
  //   ...defaults,
  //   method: API_METHODS.post,
  //   RESTPath: '/api/v1/pages/:pageId/clone',
  //   RESTPathBuild: (p) => `/api/v1/pages/${p.pageId}/clone`,
  //   params: ['pageId'],
  //   WSRoute: 'pageClone',
  // },

  //Grant Library Access
  // libraryUpdateUsers: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/libraryType/:libraryType/libraries/:libraryId/users',
  //   RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries/${p.libraryId}/users`,
  //   params: ['libraryType', 'libraryId'],
  //   WSRoute: 'libraryUpdateUsers',
  // },
  libraryGetPageByUserId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/libraries',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/libraries`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'libraryGetPageByUserId',
  },
  // libraryUpdateTeams: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/libraryType/:libraryType/libraries/:libraryId/teams',
  //   RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries/${p.libraryId}/teams`,
  //   params: ['libraryType', 'libraryId'],
  //   WSRoute: 'libraryUpdateTeams',
  // },
  // libraryGetPageByTeamId: {
  //   ...defaults,
  //   method: API_METHODS.get,
  //   RESTPath: '/api/v1/teams/:teamId/libraries',
  //   RESTPathBuild: (p) => `/api/v1/teams/${p.teamId}/libraries`,
  //   params: ['teamId'],
  //   WSRoute: 'libraryGetPageByTeamId',
  // },
  // libraryUpdateEocs: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/libraryType/:libraryType/libraries/:libraryId/cases',
  //   RESTPathBuild: (p) => `/api/v1/libraryType/${p.libraryType}/libraries/${p.libraryId}/cases`,
  //   params: ['libraryType', 'libraryId'],
  //   WSRoute: 'libraryUpdateEocs',
  // },
  libraryGetPageByEocId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/cases/:eocId/libraries',
    RESTPathBuild: (p) => `/api/v1/cases/${p.eocId}/libraries`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'libraryGetPageByEocId',
  },

  // Grant Book Access
  // bookUpdateUsers: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/books/:bookId/users',
  //   RESTPathBuild: (p) => `/api/v1/books/${p.bookId}/users`,
  //   params: ['bookId'],
  //   WSRoute: 'bookUpdateUsers',
  // },
  bookGetPageByLibraryId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/libraries/:libraryId/books',
    RESTPathBuild: (p) => `/api/v1/libraries/${p.libraryId}/books`,
    params: ['libraryId'],
    queryStrings: libraryTagQueryStrings,
    WSRoute: 'bookGetPageByLibraryId',
  },
  userBookGetPageByLibraryId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/libraries/:libraryId/books',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/libraries/${p.libraryId}/books`,
    params: ['userId','libraryId'],
    queryStrings: userLibraryTagQueryStrings,
    WSRoute: 'userBookGetPageByLibraryId',
  },
  // bookUpdateTeams: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/books/:bookId/teams',
  //   RESTPathBuild: (p) => `/api/v1/books/${p.bookId}/teams`,
  //   params: ['bookId'],
  //   WSRoute: 'bookUpdateTeams',
  // },
  // bookGetPageByTeamId: {
  //   ...defaults,
  //   method: API_METHODS.get,
  //   RESTPath: '/api/v1/teams/:teamId/books',
  //   RESTPathBuild: (p) => `/api/v1/teams/${p.teamId}/books`,
  //   params: ['teamId'],
  //   WSRoute: 'bookGetPageByTeamId',
  // },
  // bookUpdateEocs: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/books/:bookId/cases',
  //   RESTPathBuild: (p) => `/api/v1/books/${p.bookId}/cases`,
  //   params: ['bookId'],
  //   WSRoute: 'bookUpdateEocs',
  // },
  // bookGetPageByEocId: {
  //   ...defaults,
  //   method: API_METHODS.get,
  //   RESTPath: '/api/v1/cases/:eocId/books',
  //   RESTPathBuild: (p) => `/api/v1/cases/${p.eocId}/books`,
  //   params: ['eocId'],
  //   WSRoute: 'bookGetPageByEocId',
  // },
  bookUpdatePermissions: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/ownerTypes/:ownerType/owners/:ownerId/books/:bookId/canEdit/:canEdit',
    RESTPathBuild: (p) => `/api/v1/ownerTypes/${p.ownerType}/owners/${p.ownerId}/books/${p.bookId}/canEdit/${p.canEdit}`,
    params: ['ownerType', 'ownerId', 'bookId', 'canEdit'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'bookUpdatePermissions',
  },
  eocUpdateBooks: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/cases/:eocId/books',
    RESTPathBuild: (p) => `/api/v1/cases/${p.eocId}/books`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocUpdateBooks',
  },

  // Grant Page Access
  // pageUpdateUsers: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/pages/:pageId/users',
  //   RESTPathBuild: (p) => `/api/v1/pages/${p.pageId}/users`,
  //   params: ['pageId'],
  //   WSRoute: 'pageUpdateUsers',
  // },
  pageGetPageByLibraryId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/libraries/:libraryId/pages',
    RESTPathBuild: (p) => `/api/v1/libraries/${p.libraryId}/pages`,
    params: ['libraryId'],
    queryStrings: libraryTagQueryStrings,
    WSRoute: 'pageGetPageByLibraryId',
  },
  userPageGetPageByLibraryId: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/libraries/:libraryId/pages',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/libraries/${p.libraryId}/pages`,
    params: ['userId','libraryId'],
    queryStrings: userLibraryTagQueryStrings,
    WSRoute: 'userPageGetPageByLibraryId',
  },
  // pageUpdateTeams: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/pages/:pageId/teams',
  //   RESTPathBuild: (p) => `/api/v1/pages/${p.pageId}/teams`,
  //   params: ['pageId'],
  //   WSRoute: 'pageUpdateTeams',
  // },
  // pageGetPageByTeamId: {
  //   ...defaults,
  //   method: API_METHODS.get,
  //   RESTPath: '/api/v1/teams/:teamId/pages',
  //   RESTPathBuild: (p) => `/api/v1/teams/${p.teamId}/pages`,
  //   params: ['teamId'],
  //   WSRoute: 'pageGetPageByTeamId',
  // },
  // pageUpdateEocs: {
  //   ...defaults,
  //   method: API_METHODS.put,
  //   RESTPath: '/api/v1/pages/:pageId/cases',
  //   RESTPathBuild: (p) => `/api/v1/pages/${p.pageId}/cases`,
  //   params: ['pageId'],
  //   WSRoute: 'pageUpdateEocs',
  // },
  // pageGetPageByEocId: {
  //   ...defaults,
  //   method: API_METHODS.get,
  //   RESTPath: '/api/v1/cases/:eocId/pages',
  //   RESTPathBuild: (p) => `/api/v1/cases/${p.eocId}/pages`,
  //   params: ['eocId'],
  //   WSRoute: 'pageGetPageByEocId',
  // },
  pageUpdatePermissions: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/ownerTypes/:ownerType/owners/:ownerId/pages/:pageId/canEdit/:canEdit',
    RESTPathBuild: (p) => `/api/v1/ownerTypes/${p.ownerType}/owners/${p.ownerId}/pages/${p.pageId}/canEdit/${p.canEdit}`,
    params: ['ownerType', 'ownerId', 'pageId', 'canEdit'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'pageUpdatePermissions',
  },
  eocUpdatePages: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/cases/:eocId/pages',
    RESTPathBuild: (p) => `/api/v1/cases/${p.eocId}/pages`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocUpdatePages',
  },
  // Notifications
  notificationGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/notifications',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/notifications`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'notificationGetPage',
  },
  notificationCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/users/:userId/notifications',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/notifications`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'notificationCreate',
  },
  notificationUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId/notifications',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/notifications`,
    params: ['userId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'notificationUpdate',
  },

  //branding
  brandingUpdate: {
    ...defaults,
    contentType: API_HEADER_CONTENT_TYPES.multipartFormData,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    method: API_METHODS.put,
    RESTPath: '/api/v1/orgs/:orgId/branding',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/branding`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'brandingUpdate',
  },
  brandingGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/orgs/:orgId/branding',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/branding`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'brandingGetOne',
  },

  // Org Config
  orgConfigUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/orgs/:orgId/config',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/config`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'orgConfigUpdate',
  },
  orgConfigGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/orgs/:orgId/config',
    RESTPathBuild: (p) => `/api/v1/orgs/${p.orgId}/config`,
    params: ['orgId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'orgConfigGetOne',
  },

  // Calendar Objects
  calendarObjectGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/ownerId/:ownerId/calendarObjects',
    RESTPathBuild: (p) => `/api/v1/ownerId/${p.ownerId}/calendarObjects`,
    params: ['ownerId'],
    queryStrings: calendarObjectGetPageQueryStrings,
    WSRoute: 'calendarObjectGetPage',
  },
  calendarObjectCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/users/:userId/calendarObjects',
    RESTPathBuild: (p) => `/api/v1/user/${p.userId}/calendarObjects`,
    params: ['userId'],
    queryStrings: calendarObjectQueryStrings,
    WSRoute: 'calendarObjectCreate',
  },
  calendarObjectUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId/calendarObjects/:calendarObjectId',
    RESTPathBuild: (p) => `/api/v1/user/${p.userId}/calendarObjects/${p.calendarObjectId}`,
    params: ['userId', 'calendarObjectId'],
    queryStrings: calendarObjectQueryStrings,
    WSRoute: 'calendarObjectUpdate',
  },
  calendarObjectDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId/calendarObjects/:calendarObjectId',
    RESTPathBuild: (p) => `/api/v1/user/${p.userId}/calendarObjects/${p.calendarObjectId}`,
    params: ['userId', 'calendarObjectId'],
    queryStrings: calendarObjectQueryStrings,
    WSRoute: 'calendarObjectDelete',
  },
  calendarObjectUsersInvite: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/owner/:ownerId/calendarObjects/:calendarObjectId/usersInvite',
    RESTPathBuild: (p) => `/api/v1/owner/${p.ownerId}/calendarObjects/${p.calendarObjectId}/usersInvite`,
    params: ['ownerId', 'calendarObjectId'],
    queryStrings: calendarObjectQueryStrings,
    WSRoute: 'calendarObjectUsersInvite',
  },
  calendarObjectUserInviteResponse: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/owner/:ownerId/calendarObjects/:calendarObjectId/userInviteResponse',
    RESTPathBuild: (p) => `/api/v1/owner/${p.ownerId}/calendarObjects/${p.calendarObjectId}/userInviteResponse`,
    params: ['ownerId', 'calendarObjectId'],
    queryStrings: calendarObjectQueryStrings,
    WSRoute: 'calendarObjectUserInviteResponse',
  },
  polling: {
    ...defaults,
    method: API_METHODS.get,
    authorization: API_AUTH_TYPES.idToken,
    gatewayPriority: API_GATEWAY_TYPES.rest,
    RESTPath: '/api/v1/polling',
    RESTPathBuild: () => '/api/v1/polling',
    params: null,
    queryStrings: null,
    WSRoute: null,
    maskErrors: true,
  },

  // eoc export records
  eocExportRecordCreate: {
    ...defaults,
    method: API_METHODS.post,
    RESTPath: '/api/v1/eocs/:eocId/exportRecords',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/exportRecords`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocExportRecordCreate',
  },
  eocExportRecordGetPage: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/eocs/:eocId/exportRecords',
    RESTPathBuild: (p) => `/api/v1/eocs/${p.eocId}/exportRecords`,
    params: ['eocId'],
    queryStrings: defaultQueryStrings,
    WSRoute: 'eocExportRecordGetPage',
  },

  // User Walkthrough Records
  userWalkthroughGetOne: {
    ...defaults,
    method: API_METHODS.get,
    RESTPath: '/api/v1/users/:userId/walkthrough',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/walkthrough`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userWalkthroughGetOne',
  },
  userWalkthroughUpdate: {
    ...defaults,
    method: API_METHODS.put,
    RESTPath: '/api/v1/users/:userId/walkthrough',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/walkthrough`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userWalkthroughUpdate',
  },
  userWalkthroughDelete: {
    ...defaults,
    method: API_METHODS.delete,
    RESTPath: '/api/v1/users/:userId/walkthrough',
    RESTPathBuild: (p) => `/api/v1/users/${p.userId}/walkthrough`,
    params: ['userId'],
    queryStrings: userQueryStrings,
    WSRoute: 'userWalkthroughDelete',
  },
};